import { settings } from './../../../../pathways/rsm/pathway.model';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { SearchMobileFiltersModalComponent } from './search-mobile-filters-modal/search-mobile-filters-modal.component';
import { TranslateService } from '@ngx-translate/core';
import { AuthService, ModalService } from '@dg/shared-services';
import { getSelectedFilterCount } from '@app/search/components/search-view/search-reactive-store/utils';
import { SearchFilterFilter } from '@app/search/search-api.model';

@Component({
  selector: 'dgx-search-mobile-filters',
  templateUrl: './search-mobile-filters.component.html',
  styleUrls: ['./search-mobile-filters.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchMobileFiltersComponent {
  @Input() public isLoading: boolean;
  @Input() public filters: SearchFilterFilter[];
  @Input() public showFilterReset: boolean;

  @Output() public filtersChange = new EventEmitter<SearchFilterFilter[]>();
  @Output() public resetFilters = new EventEmitter<null>();

  constructor(
    private authService: AuthService,
    private translateService: TranslateService,
    private modalService: ModalService
  ) {}

  // TODO: move this to utils after Angular 14 upgrade (use `inject` for TranslateService)
  public get resetFiltersText(): string {
    const count = getSelectedFilterCount(this.filters);

    return this.translateService.instant('Core_ResetFiltersWithCount', {
      count,
    });
  }

  public showFilters(): void {
    const isClientProvider =
      this.authService.authUser.defaultOrgInfo?.settings.isClientProvider;
    const organizationName = this.authService.authUser.defaultOrgInfo?.name;
    this.modalService
      .show(SearchMobileFiltersModalComponent, {
        inputs: {
          isLoading: this.isLoading,
          isClientProvider,
          organizationName,
          filters: this.filters,
          showFilterReset: this.showFilterReset,
        },
      })
      .subscribe((result: SearchFilterFilter[]) => {
        this.filtersChange.emit(result);
      });
  }
}
